import { render, staticRenderFns } from "./AuthorityChatModal.vue?vue&type=template&id=711c2805&scoped=true&"
import script from "./AuthorityChatModal.vue?vue&type=script&lang=js&"
export * from "./AuthorityChatModal.vue?vue&type=script&lang=js&"
import style0 from "./AuthorityChatModal.vue?vue&type=style&index=0&id=711c2805&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711c2805",
  null
  
)

export default component.exports